import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface Props {
  onRetry: () => Promise<unknown> | void;
  isRetrying?: boolean;
  disabled?: boolean;
}

export function RetryNfseButton({ onRetry, isRetrying, disabled }: Props) {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => onRetry()}
      disabled={disabled || isRetrying}
    >
      <RefreshCw className={cn('mr-1 h-4 w-4', isRetrying && 'animate-spin')} aria-hidden />
      {isRetrying ? 'Tentando…' : 'Tentar novamente'}
    </Button>
  );
}
